import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
    selectors: {
        element:  '[data-modal]',
        trigger:  '[data-modal-trigger]',
        close:    '[data-modal-close]'
    },
    init: function() {
        var self  = this,
        $elements = $( self.selectors.elements );

        var $close = $( self.selectors.close ),
        modal = document.querySelector('.modal');

        disableBodyScroll( modal );
        $( document.body ).addClass( 'modal-opened' );

        $( document.body ).on( 'click', self.selectors.trigger, function(e) {
            e.preventDefault();

            disableBodyScroll( modal );
            $( document.body ).addClass( 'modal-opened' );

            return false;
        } );

        $( self.selectors.element ).on( 'click', self.selectors.close, function(e) {
            e.preventDefault();

            enableBodyScroll( modal );
            $( document.body ).removeClass( 'modal-opened' );

            return false;
        } );
    }
}

export { modal };
